<template lang="pug">
  div.datepicker-trigger(:class="rootClass" @click="checkDisable")
    lei-popover.datepicker-label-tip-box(v-if="label !== ''" :text="tip" :placement="tipPlacement")
      label.datepicker-label(:for="cbId") {{label}}
    input.datepicker-input(:id="cbId"
      :disabled="disabled" type="text"
      :placeholder="placeholder"
      :value="formatDates(dateOne, dateTwo)"
      @keyup.enter="keyEnter")
    a.clear(@click="$emit('remove')", v-if="!inputIsEmpty")
      font-awesome-icon.clear-icon(icon="times-circle")
    AirbnbStyleDatepicker(:trigger-element-id="cbId"
      @apply="apply"
      :mode="mode"
      :fullscreen-mobile="fullscreenMobile"
      :date-one="toFormat(dateOne)"
      :date-two="toFormat(dateTwo)"
      :offset-y="offsetY"
      :months-to-show="monthsToShow"
      @date-one-selected="val => {$emit('date-one-selected', fromDateFormat(val))}"
      @date-two-selected="val => {$emit('date-two-selected', toDateFormat(val))}")
</template>
<script>
import moment from 'moment'
import cdId from '../../../mixins/cd-id'
import LeiPopover from '../LeiPopover'
import expert from '../../../constants/tooltips/expert'

export default {
  components: { LeiPopover, },
  mixins: [ cdId, ],
  props: {
    label: {
      type: String,
      default: '',
    },
    rootClass: {
      type: String,
      default: 'default',
    },
    dateOne: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Select date',
    },
    dateTwo: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'range',
    },
    monthsToShow: {
      type: Number,
      default: 2,
    },
    offsetY: {
      type: Number,
      default: 10,
    },
    inputFormat: {
      type: Function,
      default: null,
    },
    fullscreenMobile: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: null,
    },
    tip: {
      type: [ String, Object, ],
      required: true,
    },
    tipPlacement: {
      type: [ String, ],
      required: true,
    },
  },
  data () {
    return {
      tooltips: expert,
    }
  },
  computed: {
    inputIsEmpty () {
      return this.dateOne === '' && this.dateTwo === ''
    },
  },
  methods: {
    fromDateFormat: (date) => date
      ? moment(date).format('YYYY-MM-DDT00:00:00' + 'Z')
      : '',
    toDateFormat: (date) => date
      ? moment(date).format('YYYY-MM-DDT23:59:59.999999' + 'Z')
      : '',
    formatDate: (date) => date
      ? moment(date).format('YYYY-MM-DDT00:00:00' + 'Z')
      : '',
    toISO: (date) => moment(date).toISOString(),
    toFormat: (date) => date ? moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD') : '',
    formatDates (dateOne, dateTwo) {
      const rangeFormat = () => !dateOne && !dateTwo ? '' : `${this.toFormat(dateOne)} – ${this.toFormat(dateTwo)}`
      const singeFormat = () => this.toFormat(dateOne)
      if (this.inputFormat) return this.inputFormat(dateOne, dateTwo)
      return this.mode === 'range' ? rangeFormat() : singeFormat()
    },
    apply () {
      // this.$emit('enter')
    },
    checkDisable (e) {
      if (this.disabled) e.stopPropagation()
    },
    keyEnter (e) {
      this.$emit('enter')
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"
  .default
    position relative
    display flex
    align-items center

    .datepicker-label
      cursor pointer
      color $default-color-middle
      font-size 87.5%
      font-weight 600
      margin-right 10px

    .datepicker-input
      font-size 85%
      text-align center
      width 155px
      padding 3px 0
      margin-right 23px
      background-color transparent
      color $default-color-bold
      font-weight 600
      border none
      border-bottom 1px solid $default-color

    .clear
      cursor pointer
      font-weight bold
      top 50%
      transform translateY(-50%)
      position absolute
      right 0
      width 1.2rem
      height 1.2rem
      display flex
      align-items center
      justify-content center
      color $default-color

      &:hover
        color $danger-color

      .clear-icon
        background-color $white-color
        border-radius 50%
</style>



// WEBPACK FOOTER //
// src/components/lei-components/inputs/DatePicker.vue